import { Component, ChangeDetectionStrategy, TemplateRef, ViewChild, inject } from '@angular/core';
import { IrisProjectSelectEngine } from '../project-select.engine';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iris-project-select-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  styles: `:host { display: none; }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
  ],
  standalone: true,
})
export class IrisProjectSelectDropdownItemComponent {
  @ViewChild('template', { static: true }) template: TemplateRef<unknown>;
  options = inject(IrisProjectSelectEngine).options;
}
